import { Content } from "antd/lib/layout/layout";
import React from "react";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import UploadTasks from "../../components/reports/UploadTasks";

function UploadTasksPage() {
  const proHeight = document.body.clientHeight;

  const left = (
    <>
      <div className="pri-font text-lg">Upload Tasks</div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <UploadTasks />
        </div>
      </Content>
    </>
  );
}

export default UploadTasksPage;
